import { createSlice } from '@reduxjs/toolkit'

const initialQuestionState = {
  question_english: '',
  question_hindi: '',
  predic_start_time: null,
  predic_end_time: null,
  admin_commission: 10,
  pred_confirm: false,
  pred_autocreate: false,
  slots_per_user: 10000,
  option:[{ id: 1, option: "OVER", isCorrect: false }, { id: 2, option: "UNDER", isCorrect: false }],
    interval: 5,
  score: 0,
  start_range: 0,
  end_range: 0,
  is_global_skiller: true,
  correct_answer: '',
  entry_fee:10
};

export const skillerSlice = createSlice({
  name: 'skiller',
  initialState: {
    question: [],
    modal_show: false,
    questionStates: initialQuestionState,
    isSubjective: false,
    isEdit:false,
    isAdd:false,
  },
  reducers: {
    stateRefresh: (state, action) => {
      state.questionStates = initialQuestionState
      state.isEdit =false
      state.isAdd=true
    },
    stateValues: (state, action) => {
      state.questionStates[action.payload.name] = action.payload.value
    },
    setEditQuestion: (state, action) => {
      state.questionStates = action.payload
      state.isEdit=action.payload.isEdit
    },
  }
})

// Action creators are generated for each case reducer function
export const { stateRefresh, stateValues, setEditQuestion } = skillerSlice.actions

export default skillerSlice.reducer